import React, { Fragment, useState, useEffect } from "react";
import {
  Row,
  Col,
  Form,
  Input,
  Label,
  InputGroup,
  Button,
} from "reactstrap";
import _ from "lodash";
import { api, ui_helpers } from "../../helpers";
import classnames from 'classnames';
import { constants, storage } from "../../utils";
import { default as useContractStore } from "./utils/useContractStore";
import Select from 'react-select'
import {DebounceInput} from "react-debounce-input";
import CFLogo from "../../assets/img/CFLogo.png";

export default function CustomerInformation({ onFindCustomer }) {
  const dealerId = useContractStore(x => x.dealerId);
  const companyId = useContractStore(x => x.companyId);
  const regionId = useContractStore(x => x.regionId);
  const setRegion = useContractStore((x) => x.setRegion);
  const setCompanyId = useContractStore((x) => x.setCompanyId);
  const setDealer = useContractStore((x) => x.setDealer);
  const firstName = useContractStore(x => x.firstName);
  const setFirstName = useContractStore(x => x.setFirstName);
  const lastName = useContractStore(x => x.lastName);
  const setLastName = useContractStore(x => x.setLastName);
  const customerPhone1 = useContractStore(x => x.customerPhone1)
  const setCustomerPhone1 = useContractStore(x => x.setCustomerPhone1)
  const secondaryPhone = useContractStore(x => x.secondaryPhone)
  const setSecondaryPhone = useContractStore(x => x.setSecondaryPhone)
  const email = useContractStore(x => x.email)
  const setEmail = useContractStore(x => x.setEmail)
  const ssn = useContractStore(x => x.ssn)
  const setSsn = useContractStore(x => x.setSsn)
  const licenseNo = useContractStore(x => x.licenseNo)
  const setLicenseNo = useContractStore(x => x.setLicenseNo)
  const dateOfBirth = useContractStore(x => x.dateOfBirth)
  const setDateOfBirth = useContractStore(x => x.setDateOfBirth)
  const culture = useContractStore(x => x.culture)
  const setCulture = useContractStore(x => x.setCulture)
  const deliveryName = useContractStore(x => x.deliveryName)
  const setDeliveryName = useContractStore(x => x.setDeliveryName)
  const deliveryAddress1 = useContractStore(x => x.deliveryAddress1)
  const setDeliveryAddress1 = useContractStore(x => x.setDeliveryAddress1)
  const deliveryAddress2 = useContractStore(x => x.deliveryAddress2)
  const setDeliveryAddress2 = useContractStore(x => x.setDeliveryAddress2)
  const deliveryCity = useContractStore(x => x.deliveryCity)
  const setDeliveryCity = useContractStore(x => x.setDeliveryCity)
  const deliveryState = useContractStore(x => x.deliveryState)
  const setDeliveryState = useContractStore(x => x.setDeliveryState)
  const deliveryZip = useContractStore(x => x.deliveryZip)
  const setDeliveryZip = useContractStore(x => x.setDeliveryZip)
  const billingName = useContractStore(x => x.billingName)
  const setBillingName = useContractStore(x => x.setBillingName)
  const billingAddress1 = useContractStore(x => x.billingAddress1)
  const setBillingAddress1 = useContractStore(x => x.setBillingAddress1)
  const billingAddress2 = useContractStore(x => x.billingAddress2)
  const setBillingAddress2 = useContractStore(x => x.setBillingAddress2)
  const billingCity = useContractStore(x => x.billingCity)
  const setBillingCity = useContractStore(x => x.setBillingCity)
  const billingState = useContractStore(x => x.billingState)
  const setBillingState = useContractStore(x => x.setBillingState)
  const billingZip = useContractStore(x => x.billingZip)
  const setBillingZip = useContractStore(x => x.setBillingZip)
  const ownershipCompanyList = useContractStore(x => x.ownershipCompanyList);
  const screenWarnings = useContractStore(x => x.screenWarnings);
  const isQuote = useContractStore(x => x.isQuote);
  const isRTO = useContractStore(x => x.isRTO);
  const dealers = useContractStore(x => x.dealers);
  const dealer = useContractStore(x => x.dealer);
  const regions = useContractStore(x => x.regions);
  const region = useContractStore(x => x.region);
  const cultures = useContractStore(x => x.cultures);
  const [dateOfBirthText, setDateOfBirthText] = useState(dateOfBirth);

  useEffect(() => {
    setDateOfBirthText(dateOfBirth);
  }, [dateOfBirth])

  function copyDeliveryToBilling() {
    setBillingName(deliveryName);
    setBillingAddress1(deliveryAddress1);
    setBillingAddress2(deliveryAddress2);
    setBillingCity(deliveryCity);
    setBillingState(deliveryState);
    setBillingZip(deliveryZip);
  }

  function maybeUpdateCompanyAndPropagateChanges(newRegionId = null, newDealerId = null) {
    if (!isRTO)
      return;
    let resolvedRegionId = newRegionId
      ? newRegionId
      : regionId;
    let resolvedDealerId = newDealerId
      ? newDealerId
      : dealerId;
    // the server binds both of these as non-nullable ints, so a missing value
    // would silently be posted as zero and resolve to no company at all
    if (!resolvedRegionId || !resolvedDealerId) return;
    api
    .post('Contract/GetRTOCompanyIdByDealerRegion', {
      dealerId: resolvedDealerId,
      regionId: resolvedRegionId
    })
    .then(r => {
      if (!r.data.success) return;
      const newCompanyId = r.data.message
        ? parseInt(r.data.message, 10)
        : null;
      // this lookup is stricter than the resolution performed on save
      // (SaveCustomerA does not filter the company/dealer relations by region),
      // so an unresolved result must not wipe out the company we already have
      if (!newCompanyId || newCompanyId === companyId) return;
      setCompanyId(newCompanyId);
    }).catch(err => console.error(err));
  }

  function onChangeRegion(value) {
    // remember to default for next time
    // and if we're a contract resolve related dealer/regions to possibly reset the company relation
    storage.setItem(constants.STORAGE_KEYS.LAST_REGION_ID, value.value);
    setRegion(value);
    maybeUpdateCompanyAndPropagateChanges(value.value, null);
  }

  function onChangeDealer(value) {
    setDealer(value);
    maybeUpdateCompanyAndPropagateChanges(null, value.value);
  }

  return (
    <Form className="mt-2">
      <Row>
        <Col>
          <div className="mb-2">
            <Label>
              First Name {ui_helpers.requiredStar()}
            </Label>
            <DebounceInput
              type="text"
              min={1}
              title={screenWarnings.firstName ? screenWarnings.firstName : null}
              className={classnames({invalid: (screenWarnings.firstName ? true : false)}, "form-control-sm form-control")}
              debounceTimeout={300}
              value={firstName}
              maxLength="25"
              autoComplete="false"
              onChange={(e) => setFirstName(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <Label>
              Last Name {ui_helpers.requiredStar()}
            </Label>
            <DebounceInput
              type="text"
              min={1}
              title={screenWarnings.lastName ? screenWarnings.lastName : null}
              className={classnames({invalid: (screenWarnings.lastName ? true : false)}, "form-control-sm form-control")}
              debounceTimeout={300}
              value={lastName}
              maxLength="25"
              autoComplete="false"
              onChange={(e) => setLastName(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <Label>Cell Phone {isQuote ? null : ui_helpers.requiredStar()}</Label>
            <DebounceInput
              type="tel"
              min={1}
              title={screenWarnings.customerPhone1 ? screenWarnings.customerPhone1 : null}
              className={classnames({invalid: (screenWarnings.customerPhone1 ? true : false)}, "form-control-sm form-control")}
              debounceTimeout={300}
              value={customerPhone1}
              maxLength="20"
              autoComplete="false"
              onChange={(e) => setCustomerPhone1(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <Label>Secondary Phone</Label>
            <DebounceInput
              type="tel"
              min={1}
              title={screenWarnings.secondaryPhone ? screenWarnings.secondaryPhone : null}
              className={classnames({invalid: (screenWarnings.secondaryPhone ? true : false)}, "form-control-sm form-control")}
              debounceTimeout={300}
              value={secondaryPhone}
              maxLength="20"
              autoComplete="false"
              onChange={(e) => setSecondaryPhone(e.target.value)}
            />
          </div>
          <div className="mb-2">
            <Label>Email</Label>
            <Input type="email" bsSize="sm" maxLength="150" value={email} autoComplete="false"
              title={screenWarnings.email ? screenWarnings.email : null}
              className={classnames({invalid: (screenWarnings.email ? true : false)})}
              onChange={(e) => setEmail(e.target.value)} />
          </div>
        </Col>
        <Col className={isQuote ? "form-col-even-quote" : "form-col-even"}>
          {isRTO ? (
            <>
              <div className="mb-2">
                <div className="float-end text-muted" style={{fontSize: "0.75rem"}}>
                  If no SSN # is available, a license number is required
                </div>
                <Label>SSN</Label>
                <InputGroup size="sm">
                  <DebounceInput
                    type="text"
                    min={1}
                    maxLength="11"
                    autoComplete="false"
                    title={screenWarnings.ssn ? screenWarnings.ssn : null}
                    className={classnames({invalid: (screenWarnings.ssn ? true : false)}, "form-control form-control-sm")}
                    debounceTimeout={300}
                    value={ssn}
                    onChange={(e) => setSsn(e.target.value)}
                  />
                  <Button color="info" className="text-light" onClick={() => onFindCustomer(ssn, '')}>
                    Find Existing
                  </Button>
                </InputGroup>
              </div>
              <div className="mb-2">
                <Label>License #</Label>
                <InputGroup size="sm">
                  <Input type="text" value={licenseNo} maxLength="20" autoComplete="false"
                    title={screenWarnings.licenseNo ? screenWarnings.licenseNo : null}
                    className={classnames({invalid: (screenWarnings.licenseNo ? true : false)})}
                    onChange={(e) => setLicenseNo(e.target.value)} />
                  <Button color="info" className="text-light" onClick={() => onFindCustomer('', licenseNo)}>
                    Find Existing
                  </Button>
                </InputGroup>
              </div>
              <div className="mb-2">
                <Label>
                  Date of Birth {ui_helpers.requiredStar()}
                </Label>
                <DebounceInput
                  type="text"
                  min={1}
                  title={screenWarnings.dateOfBirth ? screenWarnings.dateOfBirth : null}
                  className={classnames({invalid: (screenWarnings.dateOfBirth ? true : false)}, "form-control-sm form-control")}
                  debounceTimeout={300}
                  value={dateOfBirthText}
                  autoComplete="false"
                  onChange={(e) => setDateOfBirthText(e.target.value)}
                  onBlur={(e) => setDateOfBirth(e.target.value)}
                />
              </div>
            </>
            ) : null
          }
          <div className="mb-2">
            <Label>Store</Label>
            <div title={screenWarnings.dealer ? screenWarnings.dealer : null}>
              <Select
                options={dealers}
                className={classnames({invalid: (screenWarnings.dealer ? true : false)})}
                value={dealer}
                onChange={(x) => onChangeDealer(x)}
              />
            </div>
          </div>
          <div className="mb-2">
            <Label>Region {ui_helpers.requiredStar()}</Label>
            <div title={screenWarnings.region ? screenWarnings.region : null}>
              <Select
                options={regions}
                value={region}
                onChange={(x) => onChangeRegion(x)}
                classNamePrefix={screenWarnings.region ? "invalidSelect" : null}
              />
            </div>
          </div>
          <div className="mb-2">
            <Label>Preferred Contract Language</Label>
            <div title={screenWarnings.culture ? screenWarnings.culture : null}>
              <Select
                options={cultures}
                className={classnames({invalid: (screenWarnings.culture ? true : false)})}
                value={culture}
                onChange={(x) => setCulture(x)}
              />
            </div>
          </div>
        </Col>
        <Col>
          <Label>
            Delivery Address {isQuote ? null : ui_helpers.requiredStar()}
          </Label>
          <div className="mb-1">
            <DebounceInput
              type="text"
              min={1}
              title={screenWarnings.deliveryName ? screenWarnings.deliveryName : null}
              className={classnames({invalid: (screenWarnings.deliveryName ? true : false)}, "form-control-sm form-control")}
              debounceTimeout={400}
              value={deliveryName}
              maxLength="100" 
              autoComplete="off" 
              placeholder="Delivery Name" 
              onChange={(e) => setDeliveryName(e.target.value)}
            />
          </div>
          <div className="mb-1">
            <DebounceInput
              type="text"
              min={1}
              title={screenWarnings.deliveryAddress1 ? screenWarnings.deliveryAddress1 : null}
              className={classnames({invalid: (screenWarnings.deliveryAddress1 ? true : false)}, "form-control-sm form-control")}
              debounceTimeout={600}
              value={deliveryAddress1}
              maxLength="100" 
              placeholder="Delivery Address 1" 
              autoComplete="false"
              onChange={(e) => setDeliveryAddress1(e.target.value)}
            />
          </div>
          <div className="mb-1">
            <DebounceInput
              type="text"
              min={1}
              title={screenWarnings.deliveryAddress2 ? screenWarnings.deliveryAddress2 : null}
              className={classnames({invalid: (screenWarnings.deliveryAddress2 ? true : false)}, "form-control-sm form-control")}
              debounceTimeout={600}
              value={deliveryAddress2}
              maxLength="100" 
              placeholder="Delivery Address 2 (optional)"
              autoComplete="false"
              onChange={(e) => setDeliveryAddress2(e.target.value)}
            />
          </div>
          <div>
            <Row>
              <Col>
                <DebounceInput
                  type="text"
                  min={1}
                  title={screenWarnings.deliveryCity ? screenWarnings.deliveryCity : null}
                  className={classnames({invalid: (screenWarnings.deliveryCity ? true : false)}, "form-control-sm form-control")}
                  debounceTimeout={300}
                  value={deliveryCity}
                  style={{float: "left", width: "55%"}}
                  maxLength="50" 
                  placeholder="City"
                  autoComplete="false"
                  onChange={(e) => setDeliveryCity(e.target.value)}
                />
                <Input bsSize="sm" maxLength="2" type="text" placeholder="ST" autoComplete="false" style={{float: "left", width: "2.8rem", marginLeft: "2px"}}
                  title={screenWarnings.deliveryState ? screenWarnings.deliveryState : null}
                  className={classnames({invalid: (screenWarnings.deliveryState ? true : false)})}
                  value={deliveryState} onChange={(e) => setDeliveryState(e.target.value)} 
                />
                <Input bsSize="sm" maxLength="20" type="text" placeholder="Zip" autoComplete="false" style={{float: "left", width: "3.8rem", marginLeft: "2px"}}
                  title={screenWarnings.deliveryZip ? screenWarnings.deliveryZip : null}
                  className={classnames({invalid: (screenWarnings.deliveryZip ? true : false)})}
                  value={deliveryZip} onChange={(e) => setDeliveryZip(e.target.value)} />
              </Col>
            </Row>
          </div>
        </Col>
        <Col className={isQuote ? "form-col-even-quote" : "form-col-even"}>
          <Row>
            <Col>
              <Label>
                Billing Address {isQuote ? null : ui_helpers.requiredStar()}
              </Label>
            </Col>
            <Col>
              <Button color="info" size="sm" className="float-end text-light" style={{padding: "1px 6px"}} onClick={copyDeliveryToBilling}>
                Set Same as Delivery
              </Button>
            </Col>
          </Row>
          <div className="mb-1">
            <Input type="text" bsSize="sm" maxLength="100" autoComplete="off" placeholder="Billing Name" 
              title={screenWarnings.billingName ? screenWarnings.billingName : null}
              className={classnames({invalid: (screenWarnings.billingName ? true : false)})}
              value={billingName} onChange={(e) => setBillingName(e.target.value)} />
          </div>
          <div className="mb-1">
            <Input type="text" bsSize="sm" maxLength="100" placeholder="Billing Address 1" autoComplete="false"
              title={screenWarnings.billingAddress1 ? screenWarnings.billingAddress1 : null}
              className={classnames({invalid: (screenWarnings.billingAddress1 ? true : false)})}
              value={billingAddress1} onChange={(e) => setBillingAddress1(e.target.value)} />
          </div>
          <div className="mb-1">
            <Input type="text" bsSize="sm" maxLength="100"
              placeholder="Billing Address 2 (optional)" autoComplete="false"
              value={billingAddress2} onChange={(e) => setBillingAddress2(e.target.value)}
            />
          </div>
          <div>
            <Row>
              <Col>
                <Input bsSize="sm" maxLength="50" type="text" placeholder="City" autoComplete="false" style={{float: "left", width: "55%"}}
                  title={screenWarnings.billingCity ? screenWarnings.billingCity : null}
                  className={classnames({invalid: (screenWarnings.billingCity ? true : false)})}
                  value={billingCity} onChange={(e) => setBillingCity(e.target.value)} />
                <Input bsSize="sm" maxLength="2" type="text" placeholder="ST" autoComplete="false" style={{float: "left", width: "2.8rem", marginLeft: "2px"}}
                  title={screenWarnings.billingState ? screenWarnings.billingState : null}
                  className={classnames({invalid: (screenWarnings.billingState ? true : false)})}
                  value={billingState} onChange={(e) => setBillingState(e.target.value)} />
                <Input bsSize="sm" maxLength="20" type="text" placeholder="Zip" autoComplete="false" style={{float: "left", width: "3.8rem", marginLeft: "2px"}}
                  title={screenWarnings.billingZip ? screenWarnings.billingZip : null}
                  className={classnames({invalid: (screenWarnings.billingZip ? true : false)})}
                  value={billingZip} onChange={(e) => setBillingZip(e.target.value)} />
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      {isRTO || isQuote ? null : (
        <Row>
          <Col >
            <div className="mb-2">
              Click to select the company to own this cash sale:
            </div>
            {ownershipCompanyList && ownershipCompanyList.length ? (
              _.map(ownershipCompanyList, c => (
                <span
                  key={c.id}
                  className={`owner-img company-panel ${companyId === c.id ? "active" : ""}`}
                  title={c.name}
                  onClick={() => setCompanyId(c.id)}
                >
                  <img src={`api/public/GetCompanyLogo/${c.id}`} alt={`${c.name} Logo`} />
                </span>
              ))
            ) : (
              <span className="owner-img active">
                <img src={CFLogo} className="owner-img" alt="Carefree Logo" />
              </span>
            )}
          </Col>
        </Row>
      )}
    </Form>
  );
};